import { from } from '@apollo/client'
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { ProvideAuth } from './hooks/use-auth'

import localResolvers from './graphql/resolvers'

import 'react-datepicker/dist/react-datepicker.css'

// Start Apollo GraphQL configuration
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { ApolloProvider } from '@apollo/react-hooks'

const removeTypenameLink = removeTypenameFromVariables()

const cache = new InMemoryCache()

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_HOST}/graphql`,
  credentials: 'include',
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (err?.extensions?.code === 'UNAUTHENTICATED') {
        window.localStorage.removeItem('session')
        window.location.href = '/login'
      } else {
        console.log(err)
      }
    }
  }

  if (networkError && networkError.statusCode === 401) {
    window.localStorage.removeItem('session')
    window.location.href = '/login'
  }
})

const client = new ApolloClient({
  cache,
  link: from([errorLink, removeTypenameLink, httpLink]),
  //link: errorLink.concat(httpLink),
  resolvers: localResolvers,
})

// End Apollo GraphQL configuration

const root = createRoot(document.getElementById('root'))

root.render(
  <ApolloProvider client={client}>
    <ProvideAuth>
      <App client={client} />
    </ProvideAuth>
  </ApolloProvider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
